import React from 'react';
import { Card, CardContent, Typography, Avatar } from '@mui/material';
import { IStockItem, ProductCardProps } from '../../Interface/Product.interface';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../App/store';



const ProductCard: React.FC<ProductCardProps> = ({ image, name, price, mrp }) => {

    const { stockItems, loading, error } = useSelector((state: RootState) => state.pos);


  const navigate = useNavigate()

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

 
  const handleOnNavigation = (name:string) => {
   
    const filterData = stockItems.find((item:IStockItem) => item?.itemname===name)
    navigate(`/product?id=${filterData.itemid}`, { state: filterData });
    scrollToTop()
  };

  return (
    <Card sx={{ display: 'flex', alignItems: 'center', mb: 2, p: 1 }}>
      <Avatar
        src={`data:image/jpeg;base64,${image}`}
        variant="square"
        sx={{ width: 64, height: 64, mr: 2 }}

      />
      <CardContent sx={{ flex: 1, padding: '8px 0' }}>
        <Typography variant="subtitle1" component="div" onClick={()=> handleOnNavigation(name)}>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ₹{price.toFixed(2)}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
          ₹{mrp.toFixed(2)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
